import { BaseContainerModel } from '../base-container.model';
import {bl_fi_generic_doc_line_RowClass} from '../../dbschema';

export class GenericDocLineContainerModel extends BaseContainerModel {

  bl_fi_generic_doc_line: bl_fi_generic_doc_line_RowClass = new bl_fi_generic_doc_line_RowClass();
}
